module.exports = __webpack_public_path__ + "static/key-automachef-15063076a7ce112e472e2a16fe8c658e.webp";